export class BackofficeRole {
    static ROLE_SUPERADMIN = 'admin.backoffice.role.superadmin';
    static ROLE_ADMIN = 'admin.backoffice.role.admin';
    public id: number;
    public name: string;
  }
  